import { useId } from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";

interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
}

// Same frame and heading as the UI catalog section, so v1 and v2 read as separate areas.
export const AllMattersActionSection = ({
  title,
  description,
  children,
}: Props): JSX.Element => {
  const titleId = useId();
  return (
    <Paper
      component="section"
      variant="outlined"
      aria-labelledby={titleId}
      sx={{ p: { xs: 2, [MOBILE_BREAKPOINT]: 3 }, minWidth: 0 }}
    >
      <Stack spacing={2}>
        <Stack spacing={0.5}>
          <Typography id={titleId} sx={{ fontSize: "16px", fontWeight: 700 }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};
